<template>
  <div>
    <q-dialog v-model="visible" :visible="isVisible" title="质检信息查看" width="1000px" :innerScroll="false"
      @close="onCancel" :show-footer="false">
      <!-- 基本信息 -->
      <div class="content" v-loading="loading">
        <el-form :model="rowData" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="店铺名称:">
                <span class="form-item-value">{{ rowData.storeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="会话日期:">
                <span class="form-item-value">{{ rowData.sessionDt }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户ID:">
                <span class="form-item-value">{{ rowData.customerId }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客服ID:">
                <span class="form-item-value">{{ rowData.customerServiceId }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="姓名:">
                <span class="form-item-value">{{ rowData.userName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工号:">
                <span class="form-item-value">{{ rowData.workNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="岗位:">
                <span class="form-item-value">{{ rowData.workJobs }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 质检登记 -->
        <div class="quality-dialog-section-title">质检登记</div>
        <el-table :data="[rowData]" border class="quality-dialog-table">
          <el-table-column prop="qualityPersonName" label="质检人" align="center" width="70" />
          <el-table-column prop="registerDt" label="登记日期" align="center" width="100" />
          <el-table-column prop="qualified" label="是否合格" align="center" width="50" />
          <el-table-column prop="violation" label="违规项" align="center" width="150" />
          <el-table-column prop="problemDesc" label="问题描述" align="left" min-width="200" show-overflow-tooltip/>
          <el-table-column prop="deductPoints" label="扣分" align="center" width="50" />
          <el-table-column prop="qualityImgList" label="质检截图" align="center" width="100">
            <template slot-scope="{ row }">
              <el-image
                v-if="row.qualityImgList && row.qualityImgList.length"
                :src="row.qualityImgList[0]"
                :preview-src-list="row.qualityImgList"
                :initial-index="0"
                fit="cover"
                style="width: 50px; height: 50px; cursor: pointer;"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="left" min-width="150" show-overflow-tooltip/>
          <el-table-column prop="appealTime" label="申诉时效" align="center" width="80">
            <template slot-scope="{ row }">
              {{ row.appealTime ? row.appealTime + '天' : '' }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 申诉 -->
        <template v-if="complaintTableData && complaintTableData.length">
          <div class="quality-dialog-section-title">申诉操作记录</div>
          <el-table :data="complaintTableData" border class="quality-dialog-table">
            <el-table-column prop="operType" label="操作类型" align="center" min-width="100" />
            <el-table-column prop="name" label="操作人" align="center" min-width="80" />
            <el-table-column prop="operResult" label="结果" align="center" min-width="80" />
            <el-table-column prop="reason" label="原因描述" align="left" min-width="200" show-overflow-tooltip/>
            <el-table-column prop="imgUrlList" label="申诉材料" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-image
                  v-if="row.imgUrlList && row.imgUrlList.length"
                  :src="row.imgUrlList[0]"
                  :preview-src-list="row.imgUrlList"
                  :initial-index="0"
                  fit="cover"
                  style="width: 50px; height: 50px; cursor: pointer;"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="qualified" label="是否合格" align="center" min-width="90" />
            <el-table-column prop="deductPoints" label="扣分" align="center" min-width="80" />
            <el-table-column prop="creationDate" label="日期" align="center" min-width="100" />
          </el-table>
        </template>
        <!-- 审核 -->
        <!-- <template v-if="rowData.auditUserName">
          <div class="quality-dialog-section-title">审核</div>
          <el-table :data="[rowData]" border class="quality-dialog-table">
            <el-table-column prop="auditResult" label="审核结果" align="center" width="100" />
            <el-table-column prop="appeal" label="是否合格" align="center" width="100" />
            <el-table-column prop="deductPoints" label="扣分" align="center" width="80" />
            <el-table-column prop="auditReason" label="审核描述" align="center" min-width="200" />
            <el-table-column prop="auditUserName" label="审核人" align="center" width="100" />
            <el-table-column prop="auditDt" label="审核时间" align="center" width="160" />
          </el-table>
        </template> -->
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: 'QualityViewDialog',
  components: { },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      addForm: {},
      rules: {},
      loading: false,
      complaintTableData: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    init() {
      this.loading = true
      let params = {
        params: {
          qualityNo: this.rowData.qualityNo
        }
      }
      this.$q.qualityTestingManage.queryQualityRegisterLog(params).then(res => {
        this.complaintTableData = res.data
      }).finally(_ => {
        this.loading = false
      })
    },
  },
};
</script>

<style lang="stylus" scoped>
.content {
  max-height: 70vh;
  overflow-y: auto
  overflow-x: hidden
}
.quality-dialog-row {
  margin-bottom: 10px;
}
.form-item-value {
  font-weight: bold;
  color: #333;
}
.quality-dialog-section-title {
  font-weight: bold;
  margin: 16px 0 8px;
}
.quality-dialog-table {
  margin-bottom: 16px;
}
>>> .el-form-item {
  margin-bottom: 0px;
}
>>> .el-form-item__label {
  // font-weight: bold;
  color: #606266;
}
>>> .el-dialog {
  margin: 50px auto !important;
}

/* 强制表格支持换行 - 使用更高优先级的选择器 */
>>> .el-table .el-table__header-wrapper .el-table__header th {
  white-space: normal !important;
  word-break: break-all !important;
  word-wrap: break-word !important;
  line-height: 1.5 !important;
  // padding: 8px 4px !important;
  height: auto !important;
  min-height: 40px !important;
  vertical-align: middle !important;
}

/* 表头样式 */
>>> .el-table .el-table__header-wrapper .el-table__header th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: bold !important;
}

/* 表格内容样式 */
>>> .el-table .el-table__body-wrapper .el-table__body td {
  background-color: #ffffff !important;
}

/* 单元格内容强制换行 */
>>> .el-table .el-table__header-wrapper .cell {
  white-space: normal !important;
  word-break: break-all !important;
  word-wrap: break-word !important;
  line-height: 1.5 !important;
  padding: 4px !important;
}

/* 确保表格行高度自适应 */
>>> .el-table .el-table__row {
  height: auto !important;
  min-height: 40px !important;
}

>>> ::-webkit-scrollbar {
  width: 6px;
}

>>> ::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
